import { render, staticRenderFns } from "./FrontPromosIndex.vue?vue&type=template&id=241ca367"
import script from "./FrontPromosIndex.vue?vue&type=script&lang=js"
export * from "./FrontPromosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports